<template>
  <div class="shop-intro">
    <p class="shop-intro__title">店铺简介</p>
    <p class="shop-intro__subtitle">
      一般放在装修内容下方，此模块无须预览，提供占位即可。
    </p>
  </div>
</template>

<script>
export default {
  name: 'ShopIntroPreview'
}
</script>

<style lang="scss" scoped>
.shop-intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  margin: 0 auto;
  background-color: #fff;
  overflow: hidden;
  &__title {
    font-size: 24px;
  }
  &__subtitle {
    font-size: 16px;
    color: #999999;
    margin-top: 10px;
  }
}
</style>
